const returnCurrentContractColor = (contractLabel) => {
    return contractLabel === "Owner" ? "#58606C" : contractLabel === "Applicant" ? "#A296ED" : "#4EC79E"
}

export default returnCurrentContractColor
